import React, {Component} from 'react';
import {connect} from 'react-redux';
import {toastr} from 'react-redux-toastr';
import BlocksGrid from './BlocksGrid';
import BlockFilters from './BlocksFilters';
import {withStyles} from 'material-ui/styles';
import styles from './style/styles';
import {fetchedBlocks} from './actions';
import {fetchSites} from '../sites/thunks';
import {fetchBlockTypes} from './thunks';
import {
    fetchTripFormats,
    fetchDestinations,
    fetchTypesOfWork
} from '../taxonomy/thunks';
import {
    setGridFilter,
    unsetGridFilter,
} from '../grid/actions';
import {showAddGlobalButton} from '../../components/permissions/permissions';
import {Heading} from '../../components/heading/heading';
import ScrollToTop from '../../components/scroll-top/ScrollToTop';

class BlocksSettings extends Component {

    onFiltersApply() {
        this._child.reload();
    }

    componentWillMount() {
        this.props.fetchedBlocks();
        this.props.fetchSites();
        this.props.fetchDestinations();
        this.props.fetchBlockTypes();
        this.props.fetchTripFormats();
        this.props.fetchTypesOfWork();
    }

    componentWillUnmount() {
        toastr.removeByType('error');
    }

    setFilter(filter, value) {
        // ugly hack, material ui next beta dd input sucks
        if (filter === 'site_id' && value === 999) {
            value = 0;
        }

        //hmmm
        // TODO find a solution for this spagetti code

        if (filter === 'site_id' && value === -1) {
            this.props.unsetGridFilter(filter, value, this.props.gridId)
        } else if (filter === 'name' && value === '') {
            this.props.unsetGridFilter(filter, value, this.props.gridId)
        } else if (filter === 'title' && value === '') {
            this.props.unsetGridFilter(filter, value, this.props.gridId)
        } else if (filter === 'block_type_id' && value === 0) {
            this.props.unsetGridFilter(filter, value, this.props.gridId)
        } else if (filter === 'destination_id' && value === 0) {
            this.props.unsetGridFilter(filter, value, this.props.gridId)
        } else if (filter === 'trip_format_id' && value === 0) {
            this.props.unsetGridFilter(filter, value, this.props.gridId)
        } else if (filter === 'type_of_work_id' && value === 0) {
            this.props.unsetGridFilter(filter, value, this.props.gridId)
        } else {
            this.props.setGridFilter(filter, value, this.props.gridId)
        }
    }

    resetGridFilters(filters) {
        filters.map(filter =>
            this.props.unsetGridFilter(filter.id, filter.value, this.props.gridId)
        )
    }

    render() {
        return (
            <div>
                <Heading
                    title={'Blocks List'}
                    buttonTitle={'Add New Block'}
                    buttonAction={'blocks/new'}
                    showButton={showAddGlobalButton}
                />
                <BlockFilters
                    sites={this.props.sites}
                    destinations={this.props.destinations}
                    blockTypes={this.props.blockTypes}
                    tripFormats={this.props.tripFormats}
                    typesOfWork={this.props.typesOfWork}
                    classes={this.props.classes}
                    filters={this.props.blockFilters}
                    onFiltersApply={this.onFiltersApply.bind(this)}
                    setFilter={this.setFilter.bind(this)}
                    resetFilters={this.resetGridFilters.bind(this)}
                />
                <BlocksGrid
                    ref={(child) => {this._child = child}}
                    blocks={this.props.gridBlocks}
                    gridId={this.props.gridId}
                    onFetchedItems={(data, totalPages) => {
                        this.props.fetchedBlocks(data, totalPages);
                    }}
                />
                <ScrollToTop />
            </div>
        )
    }
}

const mapStateToProps = state => ({
    gridBlocks: state.blocks.all,
    sites: state.sites.allIncludingMaster,
    destinations: state.taxonomy.allDestinations,
    blockTypes: state.blocks.allBlockTypes,
    tripFormats: state.taxonomy.allTripFormats,
    typesOfWork: state.taxonomy.allTypesOfWork,
    blockFilters: state.grid.blocksGrid.filtered,
});

const ConnectedBlocksSettings = connect(mapStateToProps, {
    fetchedBlocks,
    fetchSites,
    fetchDestinations,
    fetchBlockTypes,
    fetchTripFormats,
    fetchTypesOfWork,
    setGridFilter,
    unsetGridFilter,
})(withStyles(styles)(BlocksSettings));

ConnectedBlocksSettings.defaultProps = {gridId: 'blocksGrid' };

export default ConnectedBlocksSettings;


// WEBPACK FOOTER //
// ./src/containers/blocks/index.js